import type {InfoBoxDescriptor} from '../info-box-control/info-box-control.types';

export const EMPTY_TEXT_WARNING_DESCRIPTOR: InfoBoxDescriptor = {contentKey: 'pmwjs_outlook_empty_text_warning'};

export const REPLACE_WITH_DIVIDER_CLASS_NAME = 'js-replace-with-divider';

export const CLICK_EVENT_TYPE = 'click';
